import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import type {
	CreateFieldDiaryNotePayload,
	FieldDiaryEntryDTO,
	FieldDiaryRequestOptions,
} from './types';

export const usePostFieldDiaryNote = ({
	forBinding: ownerForBinding,
}: FieldDiaryRequestOptions = {}) => {
	const queryClient = useQueryClient();
	const contextForBinding = useForBindingId();
	const forBinding = ownerForBinding ?? contextForBinding;

	return useMutation({
		mutationFn: async (data: CreateFieldDiaryNotePayload) => {
			try {
				return (
					await api.post<{ data: FieldDiaryEntryDTO }>('/field-diary/notes/create', data, {
						params: { forBinding },
					})
				).data.data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar nota no diário de campo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['fieldDiary'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao criar nota no diário de campo:',
				getApiErrorMessage(error, 'Erro ao criar nota no diário de campo')
			),
	});
};
